import { IIconBase } from '..'

const filterIcon = ({
  color = '#5A607F',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.6 1.40039H12.4C13.1333 1.40039 13.7333 2.00039 13.7333 2.73372V4.20039C13.7333 4.73372 13.4 5.40039 13.0667 5.73372L10.2 8.26706C9.8 8.60039 9.53333 9.26706 9.53333 9.80039V12.6671C9.53333 13.0671 9.26666 13.6004 8.93333 13.8004L8 14.4004C7.13333 14.9337 5.93333 14.3337 5.93333 13.2671V9.73372C5.93333 9.26706 5.66666 8.66706 5.4 8.33372L2.86666 5.66706C2.53333 5.33372 2.26666 4.73372 2.26666 4.33372V2.80039C2.26666 2.00039 2.86666 1.40039 3.6 1.40039Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.28667 1.40039L4 6.66706'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default filterIcon
